{
  "title": "Services",
  "lead": "Requirements, steps and fees of every office, and the services you can apply for online.",
  "search": "Search services",
  "office": "Office",
  "allOffices": "All offices",
  "onlyOnline": "Can apply online",
  "noMatch": "No service matches your search.",
  "emptyTitle": "No services published yet",
  "emptyBody": "Offices are adding their services here. Until then, visit or call the office.",
  "seeOffices": "See offices and contacts",
  "class_simple": "Simple",
  "class_complex": "Complex",
  "class_highly_technical": "Highly technical",
  "upToDays": "up to {count} working days",
  "applyOnlineBadge": "Apply online",
  "limitsTitle": "Processing time limits (RA 11032)",
  "limitsBody": "Under the Ease of Doing Business Act, offices must finish a service within these working days, counted from when your requirements are complete.",
  "limitsUnit": "Working days. Weekends and holidays are not counted.",
  "noRequirements": "The office has not listed requirements yet. Ask the office before you go.",
  "whereToSecure": "Where to get it: {place}",
  "noSteps": "The office has not listed the steps yet.",
  "colClient": "What you do",
  "colAgency": "What the office does",
  "colFees": "Fees",
  "colTime": "Time",
  "colResponsible": "Person responsible",
  "stepN": "Step {n}",
  "stepsCaption": "Steps for {name}",
  "backToServices": "All services",
  "notFound": "This service isn't available. The office may have removed it.",
  "shareText": "From {office} on {app}",
  "applyOnline": "Apply online",
  "applyAtOffice": "Apply in person at the {office}.",
  "downloadForm": "Download the form",
  "whoMayAvail": "Who may apply",
  "requirements": "Requirements",
  "steps": "Steps",
  "feesAndTime": "Fees and processing time",
  "fees": "Fees",
  "feesNotStated": "Not stated yet. Ask the office.",
  "processingTime": "Processing time",
  "timeNotStated": "Not stated yet.",
  "maxTime": "Maximum by law",
  "maxTimeValue": "{count} working days ({class})",
  "ra11032Short": "RA 11032 (Ease of Doing Business Act) sets the maximum processing time. It counts from when your requirements are complete.",
  "whereToGo": "Where to go",
  "location": "Location",
  "hours": "Office hours",
  "email": "Send an email",
  "rate": "Rate this service",
  "civilRegistryTitle": "Civil Registry",
  "civilRegistryLead": "Copies of birth, marriage and death records, and other civil registry services.",
  "localOrPsaTitle": "Local copy or PSA copy?",
  "localOrPsaBody": "The Municipal Civil Registry issues certified copies of records registered in the {lgu}. PSA-certified copies, often needed for passports and visas, come from the Philippine Statistics Authority (PSA).",
  "civilEmptyTitle": "No civil registry services in the app yet",
  "civilEmptyBody": "The Civil Registry hasn't published its services here yet. Visit or call the office.",
  "charterTitle": "Citizen's Charter",
  "charterLead": "What each service of the {lgu} needs, how long it takes, how much it costs, and who is responsible.",
  "charterEmptyTitle": "The charter is being prepared",
  "charterEmptyBody": "Offices are adding their services. Each office also posts its Citizen's Charter at its counter.",
  "openService": "Open the service page",
  "staffLead": "Your office's services. They appear in the Citizen's Charter, and residents can apply online for the ones you open.",
  "viewCharter": "View the public charter",
  "newService": "New service",
  "editService": "Edit service",
  "staffEmptyTitle": "No services yet",
  "staffEmptyBody": "Add each service your office offers: requirements, steps, fees and processing time. They become your Citizen's Charter in the app.",
  "hidden": "Hidden",
  "hide": "Hide",
  "show": "Show",
  "hiddenToast": "{name} is now hidden from residents.",
  "shownToast": "{name} is now visible to residents.",
  "reqCount": "Requirements: {count}",
  "moveUp": "Move {name} up",
  "moveDown": "Move {name} down",
  "removeItem": "Remove {name}",
  "editorLead": "Write it the way it appears on your Citizen's Charter. Residents see this page before they come to your office.",
  "viewPublic": "View public page",
  "sectionBasics": "About the service",
  "name": "Name of the service",
  "nameHint": "As residents know it, e.g. \"Barangay clearance\".",
  "description": "Short description",
  "descriptionHint": "One or two sentences: what residents get.",
  "whoHint": "e.g. \"Residents of the municipality, 18 and older\".",
  "sectionClass": "Classification",
  "classLegend": "How complex is this service? (RA 11032)",
  "classHint": "The law sets the maximum processing time for each class. Online requests are tracked against it.",
  "requirementsHint": "What residents must bring or upload. Add where to get each one if it comes from another office.",
  "requirementN": "Requirement {n}",
  "reqLabel": "Requirement",
  "reqWhere": "Where to get it",
  "reqNote": "Note",
  "addRequirement": "Add a requirement",
  "stepsHint": "The process as in your charter: what the client does, what your office does, fees, time and who is responsible.",
  "timePlaceholder": "e.g. 10 minutes",
  "addStep": "Add a step",
  "feesTotal": "Total fees",
  "feesHint": "e.g. \"₱50 certification fee\" or \"Per Revenue Code, Sec. 12\".",
  "timeTotal": "Total processing time",
  "timeHint": "As stated in your charter, e.g. \"1 day, 2 hours\".",
  "sectionOnline": "Online application",
  "onlineToggle": "Residents can apply online",
  "onlineHint": "Requests arrive in your office's Requests list, with a reference number and the RA 11032 deadline.",
  "onlineNote": "The applicant's full name is always asked. Every form also asks for consent under the Data Privacy Act; you don't need to add it.",
  "sectionForm": "Downloadable form",
  "formHint": "Optional. A PDF of your application form or guide that residents can print.",
  "uploadForm": "Upload a PDF",
  "uploading": "Uploading…",
  "sectionVisibility": "Visibility",
  "activeToggle": "Show in the app",
  "activeHint": "Hidden services stay saved but don't appear in Services or the charter.",
  "savedToast": "Service saved.",
  "filteredByCapability": "Showing the services of the offices that handle this.",
  "showAllServices": "Show all services"
}
